// V5: the full-screen viewer shows each whole photo in its own shape. Only
// extreme shapes are cut, to their centre part, so a panorama or a phone
// screenshot does not shrink to a thin strip. Camera and phone photos
// (3:2, 4:3, 16:9, square, portrait) are never cut.
export const WIDEST = 2.5; // 2.5 : 1
export const TALLEST = 0.5; // 1 : 2

// The width : height ratio to cut a photo to, or null to show it whole.
export const cropRatio = (width, height) => {
  if (!width || !height) {
    return null;
  }
  const ratio = width / height;
  if (ratio > WIDEST) {
    return WIDEST;
  }
  if (ratio < TALLEST) {
    return TALLEST;
  }
  return null;
};
